import React, { useState } from 'react'
import BreakingNews from '../components/BreakingNews/BreakingNews'

const BreakingNewsPage = () => {
  return (
    <>
      <BreakingNews />
    </>
  )
}

export default BreakingNewsPage
